import service from '@/store/services/vendors/employees-service';

const state = {
    list: {},
    employee: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, employee) => {
        state.employee = employee;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(employee => {
                commit('SET_RESOURCE', employee);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(employee => {
                commit('SET_RESOURCE', employee);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((employee) => {
                commit('SET_RESOURCE', employee);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((employee) => {
                commit('SET_RESOURCE', employee);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    employee: state => state.employee,
    dropdown: (state) => {
        return state.list.map(employee => ({
            uuid: employee.uuid,
            first_name: employee.first_name,
            middle_name: employee.middle_name,
            last_name: employee.last_name,
            phone_number: employee.phone_number,
            telephone_number: employee.telephone_number,
            email:employee.email,
            nida_number: employee.nida_number,
            gender: employee.gender,
            check_no: employee.check_no,
        }));
    }
};

const employees = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default employees;
